import successIcon from "../../assets/images/icons/ui/ui-icon-success.svg";

import styles from "./TemplateInterpreter.module.scss";

interface SecondaryFormSuccessProps {
  title: string;
  subtitle?: string;
  message?: string;
}

const SecondaryFormSuccess = ({
  title,
  subtitle,
  message,
}: SecondaryFormSuccessProps) => {
  const { successContainer } = styles;
  return (
    <section className={successContainer}>
      <img src={successIcon} alt="success" />
      <h1>{title}</h1>
      <p>{subtitle}</p>
      <p>{message}</p>
    </section>
  );
};

export default SecondaryFormSuccess;
